import { useQuery } from '@tanstack/react-query';
import { dashboardMainService } from 'v2/services/dashboardMain';

export const useLastGains = (startDate?: string, endDate?: string) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['dashboard', 'lastgains', startDate, endDate],
    queryFn: () => dashboardMainService.lastGain(startDate, endDate)
  });

  return { lastGains: data?.data ?? [], isLoading, error, refetch };
};
